/* ck-cart-drawer.js — slide-in mini-cart after ATC.
 * Installs window.__ckAfterAddToCart. Full /cart.js payload paints; partial
 * add.js responses re-fetch /cart.js. Fail-open → /cart. Off: theme setting
 * enable_cart_drawer, or window.__ckDisableCartDrawer = true.
 * Emits document event ck:cart-updated (full cart) for the header badge.
 * No frameworks. Depends only on Shopify Ajax Cart API.
 */
(function () {
  'use strict';
  if (window.__ckDisableCartDrawer) return;
  if (window.__ckAfterAddToCart) return; 

  var ROOT_ID = 'ck-cart-drawer-root';
  var busy = false;
  var _lastFocus = null; 

  var ESC_MAP = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  var ICON_CLOSE =
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>';
  var ICON_REMOVE =
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"/></svg>';

  

  function money(cents) { 
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    return '$' + (cents / 100).toFixed(2);
  }

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) { return ESC_MAP[c]; });
  }

  function validCart(cart) {
    
    return !!(cart && Array.isArray(cart.items) &&
      typeof cart.item_count === 'number' && typeof cart.total_price === 'number');
  }

  function focusClose() {
    var btn = document.querySelector('#' + ROOT_ID + ' .ck-cd-close');
    if (btn) btn.focus();
  }

  

  function imgTag(item) {
    if (!item.image) return '<div class="ck-cd-img" aria-hidden="true"></div>';
    var src = /^data:/.test(item.image)
      ? item.image
      : item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=120&height=120&crop=center';
    return '<img class="ck-cd-img" src="' + esc(src) + '" alt="" width="60" height="60" loading="lazy">';
  }

  
  function propsHtml(item) {
    var props = item.properties;
    if (!props || typeof props !== 'object') return '';
    var parts = [];
    for (var k in props) {
      if (!Object.prototype.hasOwnProperty.call(props, k)) continue;
      if (k.charAt(0) === '_') continue; 
      var v = props[k];
      if (v == null || String(v) === '') continue; 
      parts.push(esc(v));
    }
    return parts.length ? '<div class="ck-cd-line__props">' + parts.join(', ') + '</div>' : '';
  }

  function lineHtml(item) {
    var variant =
      item.variant_title && item.variant_title !== 'Default Title'
        ? '<div class="ck-cd-line__variant">' + esc(item.variant_title) + '</div>'
        : '';
    return (
      '<div class="ck-cd-line" data-ck-cd-line="' + esc(item.key) + '">' +
      imgTag(item) +
      '<div class="ck-cd-line__body">' +
      '<div class="ck-cd-line__title">' + esc(item.product_title) + '</div>' +
      variant +
      propsHtml(item) +
      '<div class="ck-cd-line__meta">Qty ' + item.quantity + ' &middot; ' + money(item.final_line_price) + '</div>' +
      '</div>' +
      '<button type="button" class="ck-cd-remove" data-ck-cd-remove="' + esc(item.key) + '"' +
      ' aria-label="Remove ' + esc(item.product_title) + ' from cart">' + ICON_REMOVE + '</button>' +
      '</div>'
    );
  }

  function bodyHtml(cart) {
    if (!cart.items.length) {
      return (
        '<div class="ck-cd-lines"><div class="ck-cd-empty"><p>Your cart is empty.</p></div></div>' +
        '<div class="ck-cd-foot">' +
        '<button type="button" class="ck-cd-btn ck-cd-btn--secondary" data-ck-cd-close>Continue shopping</button>' +
        '</div>'
      );
    }
    return (
      '<div class="ck-cd-lines">' + cart.items.map(lineHtml).join('') + '</div>' +
      '<div class="ck-cd-foot">' +
      '<div class="ck-cd-subtotal"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
      '<p class="ck-cd-note">Taxes &amp; shipping calculated at checkout.</p>' +
      '<a class="ck-cd-btn ck-cd-btn--primary" href="/checkout">Checkout</a>' +
      '<a class="ck-cd-btn ck-cd-btn--secondary" href="/cart">View cart</a>' +
      '<button type="button" class="ck-cd-btn ck-cd-btn--ghost" data-ck-cd-close>Continue shopping</button>' +
      '</div>'
    );
  }

  function headHtml(cart) {
    var count = cart.item_count;
    return (
      '<div class="ck-cd-head">' +
      '<span class="ck-cd-head__title">' + (count ? 'Added to cart' : 'Your cart') + '</span>' +
      '<span class="ck-cd-head__count">' + count + (count === 1 ? ' item' : ' items') + '</span>' +
      '<button type="button" class="ck-cd-close" data-ck-cd-close aria-label="Close cart">' + ICON_CLOSE + '</button>' +
      '</div>'
    );
  }

  

  function paint(cart, opening) {
    var root = document.getElementById(ROOT_ID);
    if (!root) {
      root = document.createElement('div');
      root.id = ROOT_ID;
      
      root.addEventListener('click', function (e) {
        if (!e.target.closest) return; 
        var t = e.target.closest('[data-ck-cd-remove], [data-ck-cd-close]');
        if (!t) return;
        if (t.hasAttribute('data-ck-cd-close')) close();
        else removeLine(t.getAttribute('data-ck-cd-remove'), t);
      });
      document.body.appendChild(root);
    }
    root.innerHTML =
      '<div class="ck-cd-overlay" data-ck-cd-close></div>' +
      '<aside class="ck-cd-panel" role="dialog" aria-modal="true" aria-label="Shopping cart">' +
      headHtml(cart) + bodyHtml(cart) +
      '</aside>';
    
    if (opening && !root.classList.contains('is-open')) {
      _lastFocus = document.activeElement; 
      void root.offsetWidth; 
      root.classList.add('is-open');
      document.documentElement.classList.add('ck-cd-lock');
      document.addEventListener('keydown', onKey);
      focusClose();
    }
  }

  function removeLine(key, btn) {
    if (busy || !key) return;
    busy = true;
    if (btn) btn.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('change.js ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        busy = false;
        paint(cart, false);
        try { focusClose(); } catch (e) {} 
        notifyCartUpdated(cart); 
      })
      .catch(function () {
        busy = false;
        if (btn) btn.classList.remove('is-busy');
        var line = btn && btn.closest('[data-ck-cd-line]');
        var body = line && line.querySelector('.ck-cd-line__body');
        if (body && !line.querySelector('.ck-cd-line__err')) {
          var err = document.createElement('div');
          err.className = 'ck-cd-line__err';
          err.textContent = 'Could not remove — try again or use View cart.';
          body.appendChild(err);
        }
      });
  }

  function onKey(e) {
    if (e.key === 'Escape') return close();
    if (e.key !== 'Tab') return;
    
    var panel = document.querySelector('#' + ROOT_ID + ' .ck-cd-panel');
    if (!panel) return;
    var f = panel.querySelectorAll('a[href], button:not([disabled])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function close() {
    var root = document.getElementById(ROOT_ID);
    if (root) root.classList.remove('is-open');
    document.documentElement.classList.remove('ck-cd-lock');
    document.removeEventListener('keydown', onKey);
    
    if (_lastFocus && document.contains(_lastFocus) && typeof _lastFocus.focus === 'function') {
      _lastFocus.focus();
    }
    _lastFocus = null;
  }

  
  function notifyCartUpdated(cart) {
    document.dispatchEvent(new CustomEvent('ck:cart-updated', { detail: cart }));
  }

  
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) close();
  });

  

  window.__ckAfterAddToCart = function (cart) {
    function fail() { window.location.assign('/cart'); } 
    try {
      if (window.__ckDisableCartDrawer) return fail(); 
      if (validCart(cart)) { paint(cart, true); return notifyCartUpdated(cart); } 
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('cart.js ' + r.status);
          return r.json();
        })
        .then(function (fetched) {
          if (!validCart(fetched)) throw new Error('bad cart payload');
          paint(fetched, true);
          notifyCartUpdated(fetched); 
        })
        .catch(fail);
    } catch (e) {
      fail();
    }
  };
})();
